import http from "./HttpService";

const endpoint = process.env.VUE_APP_BASE_URL;


export function fetchPerfectMoneyReports(params) {
  return http.get(`/AdminReports/perfect-money/page/${params.page}`, {
    params,
    baseURL: endpoint,
  });
}
